import React from 'react';
export function WineFeatureSection() {
  return <section className="bg-white" data-id="element-182">
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-2 min-h-[500px] md:min-h-[600px] lg:min-h-[700px]" data-id="element-183">
        {/* Text Content — Left */}
        <div className="flex flex-col justify-center px-8 md:px-12 lg:px-20 py-16 lg:py-24" data-id="element-184">
          <span className="block text-[12px] font-optima font-semibold uppercase tracking-[0.15em] text-charcoal/60 mb-4" data-id="element-185">
            Single Block
          </span>

          <h2 className="text-[28px] md:text-[34px] lg:text-[40px] font-optima font-semibold uppercase tracking-[0.12em] text-charcoal leading-[1.2] mb-8" data-id="element-186">
            2022 Ridge Block Shiraz
          </h2>

          <p className="text-[16px] md:text-[17px] lg:text-[18px] leading-[1.7] font-optima text-charcoal/80 mb-10 max-w-[560px]" data-id="element-187">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore.
          </p>

          <a href="#" className="inline-block text-[13px] font-optima font-medium uppercase tracking-[0.2em] text-charcoal underline underline-offset-4 decoration-1 hover:text-gold transition-colors duration-300" data-id="element-188">
            Shop Now
          </a>
        </div>

        {/* Bottle Image — Right */}
        <div className="relative overflow-hidden flex items-center justify-center" data-id="element-189">
          <img src="https://assets.modern-commerce.io/Glenlofty%20Project%20Files/SINGLE%20VINEYARD%20Ridge%20Shiraz.png" alt="2022 Ridge Block Shiraz bottle" className="h-[400px] md:h-[500px] lg:h-[580px] object-contain -rotate-[33deg]" data-id="element-190" />
        </div>
      </div>
    </section>;
}